import { render, staticRenderFns } from "./RegistroEntradaSaida.vue?vue&type=template&id=8990e270"
import script from "./RegistroEntradaSaida.vue?vue&type=script&lang=js"
export * from "./RegistroEntradaSaida.vue?vue&type=script&lang=js"
import style0 from "./RegistroEntradaSaida.vue?vue&type=style&index=0&id=8990e270&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports